// -----------------------------------------------------------------------------
// Script for faq list
// -----------------------------------------------------------------------------

function faq() {

  // Active faq item
  $('.faq__topic-item').click(function () {
    $('.faq__topic-item').removeClass('faq__topic-item--active');
    $(this).addClass('faq__topic-item--active');
    $('.faq__item').hide();

    var faqId = $(this).attr('data-faq');
    
    $("#" + faqId).show();

  });


  // Toggle answer
  $('.faq__question').click(function () {

    $(this).parent().toggleClass('faq__item-content--active');
    $(this).parent().find('.faq__answer').slideToggle('slow');

  });

}